import { createFileRoute } from '@tanstack/react-router'

import { ObjetivosPage } from '@/features/objectives'

export const Route = createFileRoute('/_event/objetivos/')({
  component: ObjetivosPage
})
